import { Label } from "@/components/ui/label";

export const F = ({ label, children }) => (
  <div>
    <Label className="text-xs font-semibold uppercase tracking-wider text-indigo-deep/60">{label}</Label>
    <div className="mt-1">{children}</div>
  </div>
);
